module.exports = {"baseUrl":"/cockpit-gateway/monitoring/client-view-configuration","port":8080,"preffix":"","services":{"save":"/save","find":"/find"}}